/**
 * @desc api地址配合文件
 * @author zhangy
 */

export let hostname = 'http://v4-api.h6app.com'
// export let hostname = 'http://192.168.1.26:8088';
// export let hostname = 'http://v4-api.html5case.com.cn';
// 解决协议跨域问题 动态修改协议
// if (process.client) {
const protocol = location.protocol
if (hostname.indexOf(protocol) === -1) {
  hostname = hostname.replace(/http:/, protocol)
}
// }

// 请求接口封装
export const apiConfig = {
  // 获取个人信息
  my: '/api/user/my',
  // 获取验证码
  captcha: '/api/captcha',
  // 发送短信
  sendsms: '/api/sendsms',
  // 登录
  login: '/api/login',
  // 获取案例详情
  case: '/api/case',
  // 收藏
  collect: '/api/case/collect',
  // 取消收藏
  uncollect: '/api/case/uncollect',
  // 获取收藏case
  getCollectList: '/api/user/collect',
  // 修改昵称
  editNickname: '/api/user/editNickname',
  // 修改头像
  editAvatar: '/api/user/editAvatar',
  // 日历
  calendar: '/api/calendar',
  // 绑定微信
  wxBind: '/api/user/wx_bind',
  // 微信登录
  wxLogin: '/api/user/wx_login',
  // 首页：Banner
  banner: '/api/banner',
  // 用户： 获取VIP等级
  vipconfig: '/api/vipconfig',
  // 获取所有创意tag
  ideataglist: '/api/ideataglist',
  // 搜索案例
  search: '/api/search',
  // 获取所有标签
  taglist: '/api/taglist',
  // 绑定手机
  bindPhone: '/api/user/bind_phone',
  // 案例：相关案例
  caseRelate: '/api/case/relate',
  // 推荐案例
  recommend: '/api/case/recommend',
  // 修改手机号
  editPhone: '/api/user/editPhone',
  // 发起支付
  vipPay: '/api/order/vip_pay',
  // 订单查询
  orderInquiry: '/api/order',
  // 获取首页标签
  taglisthome: '/api/taglisthome',
  // 客户需求提交
  addRequirement: '/api/addRequirement',
  // 申请成为供应商信息提交
  addSupplier: '/api/addSupplier',
  // 上传案例
  addCase: '/api/addCase',
  // 文章界面：获取热门标签
  getTaglist: '/api/taglist',
  // 文章页面：文章列表
  getArticles: '/api/getArticles',
  // 文章页面：热门文章列表
  hotArticles: '/api/hotArticles',
  // 文章页面：获取文章详情
  articleDetail: '/api/article',
  // 公司页面：公司关注/取消
  followCompany: '/api/followCompany',
  // 公司页面：公司列表
  getCompanies: '/api/getCompanies',
  // 小程序排行榜页面：排行榜列表
  getMiniPrograms: '/api/getMiniPrograms',
  // 公司页面：公司详情
  companyDetail: '/api/company'
}
